export type EducationRequirementReasonCode = {
  code: string;
  label: string;
};

const SEMINAR_TYPE = "SE";
const PORTFOLIO_TYPE = "WE";
const COURSE_MANUALS_TYPE = "RE";

const ATTENDED: EducationRequirementReasonCode = { code: "ATND", label: "Attended" };
const APPROVED: EducationRequirementReasonCode = { code: "APPR", label: "Approved" };

const REQUIREMENT_TYPE_LABELS: Record<string, string> = {
  virtual_seminar: "Virtual Seminar",
  seminar: "Seminar",
  portfolio: "Portfolio",
  course_manuals: "Course Manuals"
};

function isLevel1(levelCode: string | undefined | null): boolean {
  return Boolean(levelCode?.endsWith("1"));
}

function requirementTypeKey(requireType: string, levelCode?: string | null): string | undefined {
  switch (requireType.toUpperCase()) {
    case SEMINAR_TYPE:
      return isLevel1(levelCode) ? "virtual_seminar" : "seminar";
    case "SEMINA":
      return "seminar";
    case PORTFOLIO_TYPE:
    case "PORTFO":
      return "portfolio";
    case COURSE_MANUALS_TYPE:
      return "course_manuals";
    default:
      return undefined;
  }
}

export function getAllowedReasonCodes(requireType: string | undefined | null): EducationRequirementReasonCode[] {
  switch (requireType?.toUpperCase()) {
    case SEMINAR_TYPE:
      return [ATTENDED];
    case PORTFOLIO_TYPE:
    case COURSE_MANUALS_TYPE:
      return [APPROVED];
    default:
      return [];
  }
}

export function canEditEducationRequirementType(requireType: string | undefined | null): boolean {
  return getAllowedReasonCodes(requireType).length > 0;
}

export function getRequireTypeLabel(requireType: string | undefined | null, levelCode?: string | null): string {
  if (!requireType) {
    return "--";
  }

  const key = requirementTypeKey(requireType, levelCode);
  return (key && REQUIREMENT_TYPE_LABELS[key]) || requireType;
}

const EMPTY_REASON_CODE_OPTION = { value: "", displayText: "Please Select" };

export function buildReasonCodeSelectOptions(allowedCodes: EducationRequirementReasonCode[]) {
  return [
    EMPTY_REASON_CODE_OPTION,
    ...allowedCodes.map((reasonCode) => ({
      value: reasonCode.code,
      displayText: reasonCode.label
    }))
  ];
}
